import { PopoverBasicWithTrigger } from "@octopusdeploy/design-system-components";
import { MessageDotsIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import Markdown from "~/components/Markdown/index";
interface TemplateHelpTextProps {
    text: string | null;
}
export function TemplateHelpText({ text }: TemplateHelpTextProps) {
    if (!text) {
        return null;
    }
    return <PopoverBasicWithTrigger triggerElement={<MessageDotsIcon size={24} color={themeTokens.color.icon.tertiary}/>} description={<Markdown markup={text}/>}/>;
}
